import { createGlobalStyle } from 'styled-components';
const DocsPopupStyles = createGlobalStyle`
  body .ant-modal-content {
    border-radius: 12px;
  }

  body .docs-popup-content {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  body .docs-popup-content .title {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;

    color: #20252b;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid #eef0f3;
  }
  body .docs-popup-content .title .close-btn {
    width: 36px;
    height: 36px;
    border: none;
    background: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  body .docs-popup-content .title .close-btn img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  body .docs-popup-content .message-list {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  body .docs-popup-content .message-list > p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #3d4148;
  }

  body .docs-popup-content .message-list .message-item {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  body .docs-popup-content .message-list .message-item > img {
    width: 70px;
    height: 60px;
    object-fit: cover;
  }

  body .docs-popup-content .message-list .message-item > p {
    margin: 0;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #3d4148;
  }

  @media screen and (min-width: 576px) {
    body .docs-popup-content .message-list > p {
      font-size: 20px;
      line-height: 24px;
    }

    body .docs-popup-content .message-list .message-item > p {
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
    }

    body .docs-popup-content .title {
      font-weight: 500;
      font-size: 32px;
      line-height: 36px;
    }
  }

  @media screen and (max-width: 576px) {
    body .modal-dialog-centered {
      align-items: flex-end;
      margin: 0px;
      min-height: 100vh;
    }

    body .modal-content {
      border-radius: 12px 12px 0px 0px;
    }
  }

  /** Customize popup styles | GVL01767 2023-04-27 */

  .ant-modal.modal-dialog-centered {
    position: relative;
    top: 25%;
    left: 0;
    margin: 1.75rem auto;
  }

  body .ant-modal-wrap {
    background: rgba(0, 0, 0, 0.8);
  }

  body .ant-modal-content .ant-modal-body {
    padding: 1rem;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;

    .message {
      padding: 12px 24px;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #20252b;
      background: #ffffff;
      backdrop-filter: blur(6px);
      border-radius: 16px;
      border: 1px solid #ffffff;
      margin-top: 32px;
      text-align: center;
    }
  }

  body .modal-transparent .ant-modal-content {
    background: transparent;
  }
  
  body .loader-wp {
    position: relative;
    height: 128px;
  }
  
  @media screen and (max-width: 576px) {
    body .modal-dialog-centered {
      align-items: center;
      margin: 0px;
      min-height: 100vh;
    }
  }

  .loader {
    position: absolute;
    content: "";
    top: calc(50% - 64px);
    left: calc(50% - 64px);
    width: 128px;
    height: 128px;
    border: 8px solid transparent;
    border-radius: 50%;
    overflow: hidden;
    transition: 0.3s;
    animation: spin 1s linear infinite;
  }
  .success {
    border-color: #00d764;
  }
  .fail {
    border-color: #f3313a;
  }
  .loader.success::before {
    height: 8px;
    width: 64px;
    position: absolute;
    top: 75px;
    left: 42px;
    background-color: #00d764;
    transform: rotate(-45deg);
    transform-origin: 0% 50%;
    border-radius: 5px;
    animation: baseGrow 1s;
    content: "";
  }
  
  .loader.success::after {
    height: 8px;
    width: 38px;
    position: absolute;
    top: 75px;
    left: 47px;
    background-color: #00d764;
    transform: rotate(-135deg);
    transform-origin: 0% 50%;
    border-radius: 5px;
    animation: tipGrow 1s;
    content: "";
  }
  
  .loader.fail::before {
    width: 3rem;
    height: 0.5rem;
    background: #f3313a;
    transform-origin: 50% 50%;
    top: calc(50% - 0.25rem);
    left: calc(50% - 1.5rem);
    transform: rotate(45deg);
    position: absolute;
    content: "";
    border-radius: 10px;
    animation: leftIn 0.3s linear;
    content: "";
  }
  
  .loader.fail::after {
    width: 3rem;
    height: 0.5rem;
    background: #f3313a;
    transform-origin: 50% 50%;
    top: calc(50% - 0.25rem);
    right: calc(50% - 1.5rem);
    transform: rotate(-45deg);
    position: absolute;
    content: "";
    border-radius: 10px;
    animation: rightIn 0.3s linear;
    content: "";
  }
  
  .loader.success,
  .loader.fail {
    animation: pop 1.2s ease-in-out;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
      border-top: 8px solid #00d764;
    }
    100% {
      transform: rotate(360deg);
      border-top: 8px solid #00d764;
    }
  }
  
  @keyframes tipGrow {
    0% {
      width: 0px;
      left: 0;
      top: 0;
    }
    25% {
      width: 0px;
      left: 0;
      top: 0;
    }
    50% {
      top: 0%;
      left: 0%;
      width: 0;
    }
    75% {
      top: 0%;
      left: 0%;
      width: 0rem;
    }
    100% {
      top: 75px;
      left: 47px;
      width: 38px;
    }
  }
  
  @keyframes baseGrow {
    0% {
      width: 0;
    }
    90% {
      width: 0;
    }
    100% {
      width: 64px;
    }
  }
  
  @keyframes pop {
    0% {
      transform: scale(1);
    }
    80% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }
  
  @keyframes leftIn {
    0% {
      left: 0;
      top: 0;
      width: 0;
    }
    100% {
      top: calc(50% - 0.25rem);
      left: calc(50% - 1.5rem);
      width: 3rem;
    }
  }
  
  @keyframes rightIn {
    0% {
      rigth: 0;
      top: 0;
      width: 0;
    }
    100% {
      top: calc(50% - 0.25rem);
      right: calc(50% - 1.5rem);
      width: 3rem;
    }
  }
  
`;

export default DocsPopupStyles;
